import { useEffect } from 'react';

interface IOptions {
  inputRef: HTMLInputElement | null;
}

const useScrollBlur = ({ inputRef }: IOptions) => {
  useEffect(() => {
    const handleBlur = (event: TouchEvent) => {
      const targetTouches = event?.targetTouches;
      for (let i = 0; i < targetTouches?.length; i++) {
        if (inputRef && targetTouches?.[i]?.target !== inputRef) {
          inputRef?.blur?.();
        }
      }
    };

    window.addEventListener('touchstart', handleBlur);

    return () => {
      window.removeEventListener('touchstart', handleBlur);
    };
  }, [inputRef]);
};

export default useScrollBlur;
